import { Icon } from "../../../../components/BaseComponents/Icon";

export const TrustPilotStarIcon = (props) => (
	<Icon fill="none" viewBox="0 0 14 14" {...props}>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m7 10.67 3.04-.81L11.31 14l-4.3-3.33Zm7-5.28H8.65L7 0 5.35 5.39H0l4.33 3.24-1.64 5.32 4.33-3.3L9.7 8.62 14 5.4Z"
			clipRule="evenodd"
		/>
	</Icon>
);
